import { IRibbonProps } from '@app/models';
import * as React from 'react';

const defaultProps: IRibbonProps = {
	text: '',
	position: 'top-left',
	color: 'info',
	classNames: '',
	type: 'squared',
};

const Ribbon: React.FunctionComponent<IRibbonProps> = (props) => {
	const { text, position, color, classNames, type } = props;

	return (
		<div className={`ribbon ribbon-${type} ribbon-${position} ribbon-${color} ${classNames}`}>
			<span>{text}</span>
		</div>
	);
};

Ribbon.defaultProps = defaultProps;

export default Ribbon;



// WEBPACK FOOTER //
// ./src/components/shared/ribbon.component.tsx